import { render } from "./AdminOsszesitokView.vue?vue&type=template&id=48efd453&lang=pug"
import script from "./AdminOsszesitokView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOsszesitokView.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__